import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HelpNav from './HelpNav.jsx';
import HelpContent from './HelpContent.jsx';
import { HELP_SECTIONS, resolveHelpTarget } from './helpContent.js';
import './help.scss';

// "?" button + slide-in drawer. Opens on the topic matching the current route.
export default function HelpDrawer({ className = 'btn btn-sm btn-outline-light', floating = false }) {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [sectionId, setSectionId] = useState('welcome');
  const [topicId, setTopicId] = useState('getting-started');

  const openHelp = () => {
    const t = resolveHelpTarget(pathname);
    setSectionId(t.sectionId);
    setTopicId(t.topicId);
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open]);

  const section = HELP_SECTIONS.find((s) => s.id === sectionId) || HELP_SECTIONS[0];

  return (
    <>
      <button
        type="button"
        className={`${className}${floating ? ' help-fab' : ''}`}
        onClick={openHelp}
        aria-label="Help"
        title="Help"
      >
        <i className="fas fa-question" aria-hidden="true"></i>
      </button>
      {open && (
        <>
          <div
            className="help-backdrop"
            role="presentation"
            onClick={() => setOpen(false)}
            onKeyDown={(e) => e.key === 'Escape' && setOpen(false)}
          />
          <aside className="help-drawer" role="dialog" aria-label="Help">
            <div className="help-drawer__header">
              <strong>Help</strong>
              <button type="button" className="help-close" aria-label="Close help" onClick={() => setOpen(false)}>
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <HelpNav
              sections={HELP_SECTIONS}
              activeId={section.id}
              onSelect={(id) => {
                setSectionId(id);
                setTopicId(HELP_SECTIONS.find((s) => s.id === id).topics[0].id);
              }}
            />
            <HelpContent section={section} topicId={topicId} onSelectTopic={setTopicId} />
          </aside>
        </>
      )}
    </>
  );
}
